/* eslint-disable @typescript-eslint/no-unused-vars */
import React from 'react';
import { ColumnsType } from 'antd/lib/table/interface';
import { List, TableColumnType } from 'antd';
import TextWithStatus from 'app/components/Status/TextWithStatus';
import { TextCell } from 'app/components/Table';
import moment from 'moment';
import Button from 'app/components/Button';
import JobStatus from 'app/components/Status/JobStatus';
import {
  EllipsisOutlined,
  EditOutlined,
  DeleteOutlined,
  UndoOutlined,
  EyeOutlined
} from '@ant-design/icons';
import { StyledList } from './components/StyledListAction';
import { Popover } from './components/StyledPopover/StyledPopover';
import { MdRestore } from 'react-icons/md';
import Icon from '@ant-design/icons';

export const getColumnDefs = (
  // getColumnSearchProps: (
  //   dataIndex: string,
  //   placeholder: string
  // ) => TableColumnType<any>,
  onNavigateToDetail: (id: string) => void,
  disableInspector: (id: string) => void,
  activeInspector: (id: string) => void,
  inactiveInspector: (id: string) => void
): ColumnsType<any> => {
  return [
    {
      title: 'Name',
      dataIndex: 'name',
      key: 'name',
      // ...getColumnSearchProps('name', 'Search user name'),
      render: (_, record) => {
        const value = [record.firstName, record.lastName]
          .filter((v) => !!v)
          .join(' ');
        return <TextCell>{value}</TextCell>;
      }
    },
    {
      title: 'User Email',
      dataIndex: 'email',
      key: 'email',
      // ...getColumnSearchProps('name', 'Search user email')
    },
    {
      title: 'Contact Number',
      dataIndex: 'phone',
      key: 'phone',
      render: (value) => {
        return <TextCell>{value || 'N/A'}</TextCell>;
      }
    },
    {
      title: 'Status',
      dataIndex: 'status',
      key: 'status',
      filters: [
        {
          value: 'active',
          text: 'Active'
        },
        {
          value: 'inactive',
          text: 'Inactive'
        },
        {
          value: 'disabled',
          text: 'Disabled'
        }
      ],
      render: (value) => {
        const STATUS: any = {
          active: 'Active',
          inactive: 'Inactive',
          disabled: 'Disable'
        };

        return (
          <TextWithStatus
            status={
              value === 'inactive'
                ? 'error'
                : value === 'disabled'
                ? 'disabled'
                : 'success'
            }
          >
            {STATUS[value]}
          </TextWithStatus>
        );
      }
    },
    {
      title: 'Role',
      dataIndex: 'role',
      key: 'role',
      render: () => {
        return <TextWithStatus status={'success'}>Inspector</TextWithStatus>;
      }
    },
    {
      title: 'Web App',
      dataIndex: 'webApp',
      key: 'webApp',
      render: () => {
        return <JobStatus status="pass">Can Edit</JobStatus>;
      }
    },
    {
      title: 'Create Date',
      dataIndex: 'createdAt',
      key: 'createdAt',
      render: (value) => {
        return (
          <TextCell>
            {value ? moment(value).format('DD/MM/YYYY') : 'N/A'}
          </TextCell>
        );
      }
    },
    {
      dataIndex: 'status',
      render: (value, record) => {
        let listActions: any[] = [
          {
            type: 'text',
            label: 'Edit User',
            extra: {
              onClick: () => {
                onNavigateToDetail(record.id);
              }
            },

            icon: <EditOutlined />
          }
        ];
        if (value === 'active') {
          listActions.push({
            type: 'text',
            label: 'Inactive User',
            icon: (
              <Icon style={{ fontSize: '16px' }} component={MdRestore}></Icon>
            ),
            extra: {
              danger: true,
              onClick: () => {
                //Inactive Inspector
                inactiveInspector(record.id);
              }
            }
          });
        }
        if (value === 'inactive') {
          listActions.push({
            type: 'text',
            label: 'Active User',
            icon: (
              <Icon style={{ fontSize: '16px' }} component={MdRestore}></Icon>
            ),
            extra: {
              style: {
                color: '#32C832'
              },
              onClick: () => {
                //Active Inspector
                activeInspector(record.id);
                // disableInspector(record.id);
              }
            }
          });
        }
        listActions.push({
          type: 'text',
          label: 'Disable User',
          icon: <DeleteOutlined />,
          extra: {
            style: {
              color: '#808080'
            },
            onClick: () => {
              disableInspector(record.id);
            }
          }
        });
        if (value === 'disabled') {
          listActions = [
            {
              type: 'text',
              label: 'Edit User',
              extra: {
                onClick: () => {
                  onNavigateToDetail(record.id);
                }
              },

              icon: <EditOutlined />
            }
          ];
        }

        return value === 'disabled' ? (
          <></>
        ) : (
          <Popover
            trigger="click"
            showArrow={false}
            placement="bottom"
            title={
              <StyledList>
                {listActions.map(({ label, icon, extra }, index) => {
                  return (
                    <List.Item key={index}>
                      <Button type="text" icon={icon} {...extra}>
                        {label}
                      </Button>
                    </List.Item>
                  );
                })}
              </StyledList>
            }
          >
            <EllipsisOutlined />
          </Popover>
        );
      }
    }
  ];
};
